import { apiClient } from "./client";
import { Bot, BotCreate, BotUpdate, AIModelRegistry } from "@/types/bot";

export const botsApi = {
  getAll: async (): Promise<Bot[]> => {
    const response = await apiClient.get<{ items: Bot[], total: number }>("/bots");
    return response.data.items || [];
  },

  getById: async (botId: string): Promise<Bot> => {
    const response = await apiClient.get<Bot>(`/bots/${botId}`);
    return response.data;
  },

  getModels: async (): Promise<AIModelRegistry[]> => {
    const response = await apiClient.get<AIModelRegistry[]>("/bots/models");
    return response.data;
  },

  create: async (data: BotCreate): Promise<Bot> => {
    const response = await apiClient.post<Bot>("/bots", data);
    return response.data;
  },

  update: async (botId: string, data: BotUpdate): Promise<Bot> => {
    const response = await apiClient.put<Bot>(`/bots/${botId}`, data);
    return response.data;
  },

  delete: async (botId: string): Promise<void> => {
    await apiClient.delete(`/bots/${botId}`);
  },
};
